export class Constants {
  static ServiceAPi: string = "/DesktopModules/iMercerServices/API/Maintenance/"
  static GetJobsBySurveyId: string = "GetJobsBySurveyId";
  static GetAllActiveSurveysWithJobs: string = "GetAllActiveSurveysWithJobs";
  static LocalHostName: string = "localhost";
  static Ok: string = "OK";
  static regExpForDate: string = '^[0-9/]+$';
  static PageSize: string = "1000";
  static GetLanguage: string = "GetLanguage";
  static GetJobsBySearchText: string = "GetJobsBySearchText";
  static GetAllRegions: string = "GetAllRegions";
}
